export default __webpack_public_path__ + "static/media/barca.939a47da.png";